







































import { Component, Prop, Vue } from 'vue-property-decorator';
import CardComponent from '@/modules/core/components/CardComponent.vue';

@Component({
  components: {
    CardComponent,
  },
})
export default class EditForm extends Vue {
  @Prop()
  public cardTitle!: string;

  @Prop()
  public formModel!: any;

  @Prop({
    default: 'Annuler',
  })
  public cancelLabel!: string;

  @Prop({
    default: 'Enregistrer',
  })
  public saveLabel!: string;

  @Prop({
    default: false,
  })
  public saving!: boolean;

  @Prop({
    default: true,
  })
  public showInvalidMsg!: boolean;

  @Prop({
    default: true,
  })
  public showServerErrorMsg!: boolean;

  @Prop({
    default: null,
  })
  public saveError!: any;

  @Prop({
    default: true,
  })
  public allowSave!: boolean;

  public get showInvalidFormMsg(): boolean {
    return this.showInvalidMsg && !this.formModel.isValid;
  }

  public get showSaveErrorMsg(): boolean {
    return this.showServerErrorMsg && this.saveError;
  }

  public cancel(): void {
    this.$emit('cancel');
  }

  public save(): void {
    this.$emit('save');
  }
}
